import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Button from '../ui/Button';

function AcknowledgementScreen() {
  const { handleAcknowledge } = useAuth();
  const [isChecked, setIsChecked] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleContinue = async () => {
    if (!isChecked) {
      return;
    }

    setIsProcessing(true);
    try {
      await handleAcknowledge();
    } catch (error) {
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-3 sm:p-4 md:p-6 overflow-y-auto">
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl max-w-2xl w-full mx-auto my-auto p-4 sm:p-6 md:p-8 lg:p-12">
        <div className="text-center mb-6 sm:mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 mb-4 sm:mb-6">
            <svg className="w-16 h-16 sm:w-20 sm:h-20" id="a" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="#3b82f6"><path d="m20.5 15.5.03552-2.03558-2.03552.03558-1.5-1.5-1.5 1.5-2.03552-.03558.03552 2.03558-1.5 1.5 1.5 1.5-.03552 2.03552 2.03552-.03552 1.5 1.5 1.5-1.5 2.03552.03552-.03552-2.03552 1.5-1.5zm-1.64648.85352-2 2c-.09766.09766-.22559.14648-.35352.14648s-.25586-.04883-.35352-.14648l-1-1c-.19531-.19531-.19531-.51172 0-.70703s.51172-.19531.70703 0l.64648.64648 1.64648-1.64648c.19531-.19531.51172-.19531.70703 0s.19531.51172 0 .70703z"/><path d="m4 16h6.27679c.08527-.14691.18335-.28827.30914-.41406l.89941-.90039-.02051-1.18652c-.00879-.54199.20215-1.06445.58594-1.44824.375-.37598.88379-.58594 1.41406-.58594h.03418l1.18652.02051.90039-.89941c.78125-.78125 2.04688-.78125 2.82812 0l.90039.89941.68555-.01184v-7.47351c0-1.10461-.89545-2-2-2h-13.99998c-1.10455 0-2 .89539-2 2v10c0 1.10455.89545 2 2 2zm0-10.20538 6.59375 2.93097c.25781.11426.55469.11377.81348-.00049l6.59277-2.93048v2.18848l-5.78125 2.56964c-.3877.17188-.80322.25781-1.21875.25781s-.83105-.08545-1.21777-.25732l-5.78223-2.57013z" opacity=".3"/></g></svg>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-900 mb-3 sm:mb-4 px-2">
            Welcome to Compliance Hub
          </h2>
          <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 px-2">
            Please review and acknowledge the terms below to continue to your dashboard.
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 sm:p-5 md:p-6 mb-6 sm:mb-8">
          <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">
            Terms and Conditions
          </h3>
          <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-700">
            <p>
              Before you proceed, please acknowledge that you understand and agree to the
              following:
            </p>
            <ul className="list-disc list-inside space-y-1.5 sm:space-y-2 ml-1 sm:ml-2">
              <li>
                You are responsible for maintaining compliance with all
                applicable regulations and standards
              </li>
              <li>
                You will complete required training modules and certifications
                in a timely manner
              </li>
              <li>You will keep your profile information up to date</li>
              <li>
                You will review and respond to important notifications and
                deadlines
              </li>
              <li>
                You consent to sharing data and documentation with the customer/company
                as required for compliance and business operations
              </li>
            </ul>
          </div>
        </div>

        <div className="flex items-start mb-6 sm:mb-8">
          <input
            type="checkbox"
            id="acknowledge"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className="mt-0.5 sm:mt-1 h-4 w-4 sm:h-5 sm:w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer flex-shrink-0"
          />
          <label
            htmlFor="acknowledge"
            className="ml-2 sm:ml-3 text-xs sm:text-sm text-gray-700 cursor-pointer leading-relaxed"
          >
            I acknowledge that I have read and understood the above information
            and agree to comply with the requirements.
          </label>
        </div>

        <div className="flex justify-end">
          <Button
            variant="primary"
            size="lg"
            onClick={handleContinue}
            disabled={!isChecked || isProcessing}
            isLoading={isProcessing}
            className="w-full sm:w-auto"
          >
            Continue to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AcknowledgementScreen;

